import { Link } from '@liveauctioneers/hammer-ui-core/link';
import Image from 'next/image';
import proxibidSellerPortalLogo from 'public/images/proxibid.svg';

type Props = {
    href?: string;
    small?: boolean;
    /** Override when several logos coexist in the DOM (e.g. the CSS-hidden mobile bar). */
    testId?: string;
};

export const AtgSellerPortalLogo = ({ href = '/', small = false, testId = 'logo-link' }: Props) => {
    return (
        <Link
            data-testid={testId}
            data-wb-id="AtgSellerPortalLogo"
            href={href}
        >
            <Image
                alt="Proxibid Seller Portal Logo"
                src={proxibidSellerPortalLogo}
                width={small ? 30 : 104}
            />
        </Link>
    );
};

AtgSellerPortalLogo.displayName = 'AtgSellerPortalLogo';
